import React from 'react';
import { ContactSection } from './ContactSection';

/**
 * Thin wrapper around the contact section.
 *
 * The commented-out `PricingPlansSection` and `CompetitiveAdvantageSection`
 * imports were removed rather than left in place — they failed the production
 * build under `CI=true`, which treats unused vars as errors. Pricing is
 * rendered directly by LandingPage; CompetitiveAdvantageSection is unrendered
 * legacy.
 *
 * The wrapper's three-stop gradient was replaced with the flat ground used
 * across the catalogue, so ContactSection no longer sits on a different
 * background from every section around it.
 */
export const MainContactResearch = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-[#0d1117] py-8 lg:py-16">
      <ContactSection />
    </div>
  );
};
